import useMediaQuery from '@mui/material/useMediaQuery';
import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import { isWebpSupported } from 'react-image-webp/dist/utils';
import { imageProxy } from 'tf-post-parser';
import { getAccount } from '../../helpers/hive';
import PhotoHeader from '../General/PhotoHeader';
import PostGrid from '../Grid/PostGrid';
import Head from '../Header/Head';
import Header from '../Header/Header';
import CommunityAbout from './CommunityAbout';
import CommunitySidebar from './CommunitySidebar';
import CommunityTabs from './CommunityTabs';

const StickyBox = dynamic(() => import('react-sticky-box'), {
  ssr: false,
});

const Community = props => {
  const [coverImage, setCoverImage] = useState('');

  const { name, title, about, lang } = props.community;

  const id = parseInt(name.substring(5, 11));

  const [screenWidth, setScreenWidth] = useState(1920);
  const [webpSupport, setWebpSupport] = useState(undefined);
  const [sortTitle, setSortTitle] = useState('Newest');
  const [orderby, setOrderBy] = useState('createdAt');
  const [showAbout, setShowAbout] = useState(false);

  const handleChangeSort = properties => {
    setSortTitle(properties.title);
    setOrderBy(properties.orderby);
  };

  useEffect(() => {
    setScreenWidth(Math.ceil(window.innerWidth / 100) * 100);
    setWebpSupport(isWebpSupported());
    getAccount(props.community.name).then(profile => {
      if (profile.coverImage) setCoverImage(profile.coverImage);
      else
        setCoverImage(
          'https://images.hive.blog/p/vM1pGHgNcyCbeeHc87msUy15a6gssa8TxcCWDULWJwXbLzzTNUCuGN3v6fTG1Cxa3iA7dj2rixvqQw5FRuewtFGmCt4r68CcjssuoSnko5jXFk1x2hcHhcFRVCJFWE3Jf3rfCez',
        );
    });
  }, [props]);

  const breadcrumbs = [
    {
      position: 1,
      name: 'Communities',
      item: `https://travelfeed.com/communities`,
    },
    {
      position: 2,
      name: title,
      item: `https://travelfeed.com/communities/${id}`,
    },
  ];

  const renderLeftSidebar = useMediaQuery('(min-width: 1200px)');
  const renderRightSidebar = useMediaQuery('(min-width: 768px)');

  return (
    <>
      <Head
        language={lang}
        title={title}
        image={coverImage}
        description={about}
        breadcrumbs={breadcrumbs}
        feedUrl={`communities/${id}`}
      />
      <Header
        active="communities"
        subheader={title}
        community={name}
        drawerItems={<CommunitySidebar active={id} />}
        drawerBreakSize="lg"
      />
      <div className="container containerInvisibleOnMobile">
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-4 d-none d-xl-block d-lg-block d-md-block">
            {renderLeftSidebar ? (
              <StickyBox offsetTop={65} offsetBottom={10}>
                <div className="row">
                  <div className="col-xl-9 col-12">
                    <CommunitySidebar active={id} />
                  </div>
                </div>
              </StickyBox>
            ) : (
              <></>
            )}
          </div>
          <div className="col-xl-9 col-lg-12 col-md-12 col-sm-12 p-0">
            <PhotoHeader
              communityTag
              title={title}
              description={about}
              image={imageProxy(
                coverImage,
                screenWidth,
                500,
                undefined,
                webpSupport ? 'webp' : undefined,
              )}
              query={{}}
              tag={name}
              lang={lang}
            />
            <div className="container-fluid">
              {!renderRightSidebar && (
                <CommunityTabs
                  handleChangeSort={handleChangeSort}
                  community={props.community}
                  setShowAbout={setShowAbout}
                />
              )}
              <div className="row pb-2">
                <div className="col-xl-7 col-lg-8 col-md-8 col-sm-12 col-12">
                  {showAbout ? (
                    <CommunityAbout community={props.community} />
                  ) : (
                    <PostGrid
                      active="topic"
                      query={{
                        community: id,
                        orderby,
                        limit: 9,
                      }}
                      grid={{ lg: 12, md: 12, sm: 12, xs: 12 }}
                      cardHeight={200}
                      poststyle="grid"
                    />
                  )}
                </div>
                <div className="col-xl-5 col-lg-4 col-md-4">
                  {renderRightSidebar ? (
                    <StickyBox offsetTop={65} offsetBottom={10}>
                      <CommunityAbout
                        handleChangeSort={handleChangeSort}
                        sortTitle={sortTitle}
                        community={props.community}
                      />
                    </StickyBox>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Community;
